var render, staticRenderFns
import script from "./ReadController.vue?vue&type=script&lang=js&"
export * from "./ReadController.vue?vue&type=script&lang=js&"
import style0 from "./ReadController.vue?vue&type=style&index=0&id=1f4c4d60&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4c4d60",
  null
  
)

export default component.exports